// extracted by mini-css-extract-plugin
export default {"box":"box__y3VCq","avatar":"avatar__FV8Xl","img":"img__r3uQW","icon":"icon__0qV+Z"};